import * as ActionTypes from '../../constants/design/MenuActionTypes'

export const receiveAllData = (types, menus, isEditableMenu) => ({
	type: ActionTypes.RECEIVE_ALL_DATA,
	types,
	menus,
    isEditableMenu
})

export const addMenu = (menu) => ({
	type: ActionTypes.ADD_MENU,
	menu
})

export const deleteMenu = (index) => ({
	type: ActionTypes.DELETE_MENU,
	index
})

export const moveMenu = (dragIndex, hoverIndex, isTemporary) => ({
	type: ActionTypes.MOVE_MENU,
	dragIndex, hoverIndex, isTemporary
})

export const dropMenu = (dragIndex) => ({
	type: ActionTypes.DROP_MENU,
	dragIndex
})

export const afterSave = () => ({
	type: ActionTypes.AFTER_SAVE
})
